import { fmt } from "@/components/CartDrawer";

export default function Price({ product, className = "", size = "md" }) {
  const hasWholesale = product?.wholesale_price != null;
  const textSize = size === "lg" ? "text-3xl" : "text-xl";
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid={`price-${product.slug}`}>
      <span className={`font-display ${textSize} font-black text-slate-100`}>{fmt(product.price)}</span>
      {hasWholesale && (
        <span className="border border-hivis/40 px-2 py-0.5 font-mono text-[11px] uppercase tracking-widest text-hivis" data-testid={`wholesale-price-${product.slug}`}>
          Dealer {fmt(product.wholesale_price)}
        </span>
      )}
    </div>
  );
}
